<template>
  <div class="press-release-block" style="padding-top: 10px;padding-bottom: 5px">
    <h6>{{ data.timeOverride || data.dateStr }}</h6>
    <h4>{{ data.title }}</h4>
    <div v-if="data.description" v-html="data.description"></div>
    <h6 class="action" v-if="data.actionText">
      <b-link target="_blank" :href="data.actionLink">{{ data.actionText }}</b-link>
    </h6>
  </div>
</template>

<style>

.action {
  margin-bottom: 0
}

</style>

<script>

export default {
  props: {
    data: Object,
  },
  methods: {
    onclick() {
    }
  }
}

</script>
